import { GraphObject, Link, Shape } from 'gojs';
import { orchestrationDiagramConfig } from '../../config/orchestration-diagram.config';
import { linkContextMenuBinding, linkDeleteableBinding, linkStrokeBinding } from './utils/bindings';
import { mouseHover, mouseLeave } from './utils/events';

const $ = GraphObject.make;

export const LinkTemplateMap = () => ({
  category: '',
  template: LinkTemplate(),
});

const LinkTemplate = () =>
  $(
    Link,
    {
      selectionAdorned: false,
      routing: Link.AvoidsNodes,
      corner: 15,
      curve: Link.JumpOver,
      mouseHover,
      mouseLeave,
    },
    linkShape(),
    linkArrow(),
    linkDeleteableBinding(),
    linkContextMenuBinding(),
  );

const linkShape = () =>
  $(Shape, { strokeWidth: 2, stroke: orchestrationDiagramConfig.link.colors.primary }, linkStrokeBinding());

const linkArrow = () =>
  $(
    Shape,
    { toArrow: 'OpenTriangle', strokeWidth: 2, stroke: orchestrationDiagramConfig.link.colors.primary },
    linkStrokeBinding(),
  );
